module.exports = __webpack_public_path__ + "static/img/main-logo.b5108ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/main-logo.png
// module id = DMDf
// module chunks = 3